// dependencies
import request from "axios";

// constants
import Lifecycle from "../../constants/APILifecycle";
import AdministrationParser from "./services/Administration";
import AutocompleteParser from "./services/Autocomplete";
import FeedbackParser from "./services/Feedback";
import GroupsParser from "./services/Groups";
import HashtagParser from "./services/Hashtags";
// services
import JobsParser from "./services/Jobs";
import ReviewsParser from "./services/Reviews";
import SelectionsParser from "./services/Selections";
import UsersParser from "./services/Users";

const DataService = () => (next) => (action) => {
	/*
            Pass all actions through by default.
        */

	let RequestData = null;
	let cancelSignalToken = null;
	const serviceName = action.type.split(":")[0];

	switch (serviceName) {
		case "AUTOCOMPLETE":
			RequestData = AutocompleteParser(action.type.split(":")[1], action);
			break;

		case "FEEDBACK":
			RequestData = FeedbackParser(action.type.split(":")[1], action);
			break;

		case "USERS":
			RequestData = UsersParser(action.type.split(":")[1], action);
			cancelSignalToken = action.signalToken;
			break;

		case "HASHTAGS":
			RequestData = HashtagParser(action.type.split(":")[1], action);
			break;

		case "SELECTIONS":
			RequestData = SelectionsParser(action.type.split(":")[1], action);
			break;

		case "GROUPS":
		case "DEPARTMENTS":
			RequestData = GroupsParser(action.type.split(":")[1], action);
			break;

		case "REVIEWS":
			RequestData = ReviewsParser(action.type.split(":")[1], action);
			break;

		case "JOBS":
			RequestData = JobsParser(action.type.split(":")[1], action);
			break;

		case "ADMIN":
			RequestData = AdministrationParser(action.type.split(":")[1], action);
			break;

		default:
			RequestData = null;
			break;
	}

	if (RequestData === null) {
		return next({ ...action });
	}

	const { type: actionType, ...actionData } = action;

	next({ type: `${actionType}@${Lifecycle.get("start")}`, ...actionData });

	const requestConfig = {
		method: RequestData.type,
		url: RequestData.url,
		headers: {
			"X-XSRFToken": window.xsrf_val, // for some reason, /ajax/hris/temp-save-employee-query/ needed this header
			"X-Xsrf-Token": window.xsrf_val,
			Accept: "application/json",
		},
		cancelToken: cancelSignalToken,
	};

	if (RequestData.payload) {
		if (RequestData.type === "GET") {
			requestConfig.params = RequestData.payload;
		} else {
			requestConfig.data = RequestData.payload;
		}
	}

	return request(requestConfig)
		.then((response) => {
			const myResponse = {
				status: Math.floor(response.status / 100),
				statusCode: response.status,
				data: response.data,
				response,
			};

			if (myResponse.status !== 2) {
				next({
					type: `${actionType}@${Lifecycle.get("fail")}`,
					...actionData,
					response: myResponse,
				});
			} else {
				next({
					type: `${actionType}@${Lifecycle.get("success")}`,
					...actionData,
					response: myResponse,
					data: myResponse.data,
				});
			}

			if (action.callback) {
				action.callback(myResponse, action);
			}
		})
		.catch((error) => {
			const myResponse = {
				status: 0,
				statusCode: 0,
				data: {},
				response: {},
				request: {},
			};

			if (error.response) {
				// The request was made and the server responded with a status
				// code that falls out of the range of 2xx
				myResponse.data = error.response.data;
				myResponse.statusCode = error.response.status;
				myResponse.response = error.response.response;
				myResponse.status = Math.floor(error.response.status / 100);
			} else if (error.request) {
				// The request was made but no response was received
				// `error.request` is an instance of XMLHttpRequest in the
				// browser and an instance of
				myResponse.request = error.request;
			}

			next({
				type: `${actionType}@${Lifecycle.get("fail")}`,
				...actionData,
				response: myResponse,
			});
		});
};

export default DataService;
